import { render } from "./index.vue?vue&type=template&id=bfbcfdd2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/action-card/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfbcfdd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfbcfdd2', __exports__)) {
    api.reload('bfbcfdd2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bfbcfdd2", () => {
    api.rerender('bfbcfdd2', render)
  })

}


export default __exports__